import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import BeforeAfter from './components/before-after'
import ScratchBeforeAfter from './components/scratch-before-after'
import './client.module.css'
import './components/before-after.module.css'
import './components/scratch-before-after.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends HTMLElement {
  connectedCallback() {
    safeDefine('dh-before-after', BeforeAfter)
    safeDefine('dh-scratch-before-after', ScratchBeforeAfter)
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
